import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propShape } from '../../../../helpers/custom-prop-types';
import PlainTextAreaComponent from '../../../Ui/Common/PlainTextAreaComponent';
const ProfessionalUnitCompanyContactContentField = (props) => {
    const { input, meta } = props;
    return (_jsx("div", Object.assign({ className: 'field' }, { children: _jsxs("label", { children: [_jsx("div", Object.assign({ className: 'field_title' }, { children: _jsx("span", { children: "\u554F\u3044\u5408\u308F\u305B\u5185\u5BB9" }) })), _jsx(PlainTextAreaComponent, { autosized: true, className: 'input-form-textarea', input: input, meta: meta, placeholder: '＜記載例＞\n・〇〇の業務についてどのようなサービスを提供して頂けるか教えてください。\n・〇〇のような領域で支援頂く場合どの程度の予算がかかるか教えてください。\n・〇〇のテーマでのこれまでのプロジェクト実績についてご紹介ください。' })] }) })));
};
ProfessionalUnitCompanyContactContentField.propTypes = {
    input: propShape().isRequired,
    meta: propShape().isRequired,
};
export default ProfessionalUnitCompanyContactContentField;
